const openCollapsibleOptionsByDefault = () => {

  const ids = [];
  
  const clickOpenBtns = (e) => {
    return new Promise((res) => {
      setTimeout(() => {
        const btns = document.querySelectorAll('.cpb-category-collapse-button');
        btns.forEach(btn => {
          if (btn.closest('.cpb-category-collapse') && !ids.includes(btn.closest('.cpb-category-collapse').dataset.categoryId)) btn.click();
        });
        res();
      }, 250);
    })
  }

  const markClickedOptions = () => {
    const options = document.querySelectorAll('.cpb-category.cpb-category-collapse-active');
    const observer = new MutationObserver((entries) => {
      entries.forEach(entry => {
        ids.push(entry.target.dataset.categoryId);
      });
    });

    options.forEach(option => {
      observer.observe(option, { attributes: true, attributeFilter: [ "class" ] });
    })
  }

  document.body.addEventListener('CPB_ON_UPDATE_CURRENT_TAB', async () => {
    await clickOpenBtns();
    markClickedOptions();
  });
  document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', async () => {
    await clickOpenBtns();
    markClickedOptions();
  });
  clickOpenBtns();
}

const hidePriceIfNoLogin = () => {
  if (window._cpbCustomData?.customer) return

  const hidePrices = () => {
    const priceElems = document.querySelectorAll('.cpb-product-price');
    priceElems.forEach(el => el.innerHTML = '');
  };

  document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', hidePrices);
}

const hideAddToCartButton = () => {
  const addToCartButton = document.querySelector('.cpb-add-to-cart-button')
  addToCartButton.style.display = 'none'
  document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', () => {
    const product = CPB.getStore().getState().Product;
    
    const panelIds = product.panels.map(panel => panel.id);

    const layerPanelIds = new Set(product.layers.map(layer => layer.panel));

    const isAllOptionsSelected = panelIds.every(id => layerPanelIds.has(id));

    if (isAllOptionsSelected) {
      addToCartButton.style.display = 'block' 
    } else {
      addToCartButton.style.display = 'none'
    }
  });
};

document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', function(event) {
  openCollapsibleOptionsByDefault();
  hidePriceIfNoLogin();
  hideAddToCartButton();
})